
import React from 'react';

import './index.css';

import classNames from 'classnames';



export default function FlexLayout(props) {
  let {className, children, ...rest} = props;

  className = classNames('component-flex-layout', className);

  return (
    <div {...rest} className={className}>{children}</div>
  );
}


export function FlexLayoutHeader(props) {
  let {children, ...rest} = props;

  return (<header {...rest}>{children}</header>);
}

export function FlexLayoutBody(props) {
  let {children, ...rest} = props;

  return (<main {...rest}>{children}</main>);
}


export function FlexLayoutFooter(props) {
  let {children, ...rest} = props;

  return (<footer {...rest}>{children}</footer>);
}



// WEBPACK FOOTER //
// ./src/components/FixedLayout/flex/index.js